import { RuntimeConfig } from "nuxt/schema";
import { ProductPreviewForReviewType } from "~/types/shop/ProductPreviewForReviewType";
import { ProductPreviewEntity } from "~/entities/shop/ProductPreviewEntity";

export const ProductPreviewForReviewEntity = function (data: any, config: RuntimeConfig): ProductPreviewForReviewType {
    return {
        product: ProductPreviewEntity(data?.product?.data, config),
        highlight: data?.highlight,
    };
};